import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useThumbnailManualReady } from '@elfsight/configurator-preview';
import { FreeLink, pickFreeLinkSettings } from '@elfsight/widget-free-link';
import { createCustomCSSPrefixClassName, EmbedRoot } from '@elfsight/widget-ui';
import { useBreakpoints } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { useRect } from 'react-use-rect';
import { classnamePrefix, TABLET_WIDTH } from '../constants';
import { meta } from '../meta';
import { Content, Deactivation } from './components';
import { Layout } from './components/layouts';

export function Widget() {
  const {
    width,
    renderThumbnailMode,
    widgetId,
    galleryTitle,
    backgroundColor,
    textColor,
    ...settings
  } = useSettings();
  const freeLinkSettings = pickFreeLinkSettings(settings);

  const [enableThumbnailReadyListener, resolveThumbnailReadyListener] =
    useThumbnailManualReady(renderThumbnailMode);

  const [breakpoints, ref] = useBreakpoints(TABLET_WIDTH);
  const [innerWidth, setInnerWidth] = useState(0);
  const [setWidthRef] = useRect(
    (rect) => {
      setInnerWidth(rect.width);
    },
    { resize: true }
  );

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.appAlias,
    widgetId
  );

  useEffect(() => {
    enableThumbnailReadyListener();
  }, [enableThumbnailReadyListener]);

  return (
    <Deactivation>
      <EmbedRoot customCSSClassName={customCSSPrefixClassName} width={width}>
        <Component
          ref={ref}
          onLoad={() => resolveThumbnailReadyListener()} // Короткая запись onLoad={resolveThumbnailReadyListener} не работает по неустановленным причинам
        >
          {!!galleryTitle && <Title>{galleryTitle}</Title>}

          <Inner
            ref={setWidthRef}
            _backgroundColor={backgroundColor}
            _textColor={textColor}
          >
            <Content>
              <Layout
                mobile={breakpoints[TABLET_WIDTH]}
                widgetWidth={innerWidth}
              />
            </Content>
          </Inner>
          <FreeLink
            {...freeLinkSettings}
            appAlias={meta.appAlias}
            appName={meta.appName}
            style={{
              link: {
                marginTop: '20px'
              }
            }}
          />
        </Component>
      </EmbedRoot>
    </Deactivation>
  );
}

const Component = styled.div.attrs({
  className: `${classnamePrefix}-vimeo-gallery-component`
})``;

const Inner = styled.div.attrs({
  className: `${classnamePrefix}-vimeo-gallery-inner`
})`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ _backgroundColor }) =>
    _backgroundColor || 'transparent'};
  color: ${({ _textColor }) => _textColor || 'inherit'};
  ${({ _backgroundColor }) => _backgroundColor && 'padding: 20px;'};
`;

const Title = styled.div.attrs({
  className: `${classnamePrefix}-vimeo-gallery-title`
})`
  width: 100%;
  padding-bottom: 0;
  margin-bottom: 24px;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  color: currentColor;
`;
